import React, { useContext } from 'react'
import { 
  Container,
  StructuresContainer,
} from './style'
import ManageStructures from '../../../../components/Certificates/AddParameter/ManageStructures'
import ParameterStructures from '../../../../components/Certificates/AddParameter/Structures'
import AddParamButtonsDiv from '../../../../components/Certificates/AddParameter/ButtonsDiv'

const AddParameterContent: React.FC = () => {
  
  return (
      <Container>
        <ManageStructures />
        <StructuresContainer>
          <ParameterStructures/>
          <AddParamButtonsDiv />
        </StructuresContainer>
      </Container>
  )
}
export default AddParameterContent
